import React, { useState, useEffect } from 'react';
import OrderTable from '../components/OrderTable';
import { orderService } from '../api/orderService';
import { Order } from '../types/order';
import { toast } from 'react-toastify';

const OrderPage: React.FC = () => {
    const [orders, setOrders] = useState<Order[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(200);
    const [totalItems, setTotalItems] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [availableStatuses, setAvailableStatuses] = useState<{value: string, label: string}[]>([]);

    useEffect(() => {
        fetchFilters();
    }, []);

    useEffect(() => {
        fetchOrders();
    }, [currentPage, itemsPerPage, searchTerm, selectedStatus]);

    const fetchOrders = async () => {
        try {
            setIsLoading(true);
            const response = await orderService.fetchOrders(
                currentPage,
                itemsPerPage,
                searchTerm,
                selectedStatus
            );

            if (response) {
                setOrders(response.member);
                setTotalItems(response.totalItems);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des commandes:', error);
            toast.error('Erreur lors du chargement des commandes');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchFilters = async () => {
        try {
            setAvailableStatuses([
                { value: 'preparation', label: 'preparation' },
                { value: 'generation', label: 'generation' },
                { value: 'fabrication', label: 'fabrication' },
                { value: 'expedition', label: 'expedition' },
                { value: 'erreur', label: 'erreur' }
            ]);
        } catch (error) {
            console.error('Erreur lors de la récupération des filtres:', error);
        }
    };

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };

    const handleItemsPerPageChange = (newItemsPerPage: number) => {
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1);
    };

    const handleSearch = (term: string) => {
        setSearchTerm(term);
        setCurrentPage(1);
    };

    const handleStatusFilter = (status: string) => {
        setSelectedStatus(status);
        setCurrentPage(1);
    };

    return (
        <div className="mx-auto w-full max-w-screen-2xl px-3 py-4 sm:px-4 lg:px-6">
            <div className="mb-4 flex flex-col gap-1 sm:mb-6 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <h1
                        className="text-xl font-bold text-gray-700 sm:text-2xl md:text-3xl"
                        style={{ position: 'relative', zIndex: '1' }}
                    >
                        Liste des Commandes
                    </h1>
                    <p className="mt-1 text-sm text-gray-500 sm:hidden">
                        Faites défiler le tableau horizontalement si nécessaire.
                    </p>
                </div>
            </div>

            <div className="w-full overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-gray-200">
                <div className="w-full overflow-x-auto">
                    <div className="min-w-[760px] lg:min-w-0">
                        <OrderTable
                            orders={orders}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            totalItems={totalItems}
                            isLoading={isLoading}
                            onPageChange={handlePageChange}
                            onItemsPerPageChange={handleItemsPerPageChange}
                            searchTerm={searchTerm}
                            onSearch={handleSearch}
                            onStatusFilter={handleStatusFilter}
                            availableStatuses={availableStatuses}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderPage; 